import { render, staticRenderFns } from "./ManageOrderList.vue?vue&type=template&id=08816eca&scoped=true&"
import script from "./ManageOrderList.vue?vue&type=script&lang=js&"
export * from "./ManageOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrderList.vue?vue&type=style&index=0&id=08816eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08816eca",
  null
  
)

export default component.exports